export default (env: any) => {
    env.build.buildDate = '20251209021448';
    env.build.buildDateEpoch = 1765217688726;
    env.build.buildRevision = 'd5d584985035bb6284851a79eae4363c0624e348';
    env.build.part = 'mgr';
    env.build.deployment = 'prd';
    env.production = 'false';
    env.settings.apiRoot = '/api';
};
